export interface SendVerificationCodeRequest {
  telefono: string;
}

export interface SendVerificationCodeResponse {
  success: boolean;
  message: string;
  devCode?: string;
}

export interface VerifyCodeRequest {
  telefono: string;
  code: string;
}

export interface VerifyCodeResponse {
  success: boolean;
  message: string;
}

class SmsVerificationService {
  private baseUrl: string;

  constructor() {
    this.baseUrl = import.meta.env.VITE_API_BASE_URL || 'https://localhost:7123/api';
  }

  private async request<T>(
    endpoint: string,
    options: RequestInit = {}
  ): Promise<T> {
    const url = `${this.baseUrl}${endpoint}`;

    const headers: Record<string, string> = {
      'Content-Type': 'application/json',
      ...(options.headers as Record<string, string> || {}),
    };

    const response = await fetch(url, {
      ...options,
      headers,
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.message || `Error HTTP: ${response.status}`);
    }

    return data;
  }

  async sendVerificationCode(telefono: string): Promise<SendVerificationCodeResponse> {
    try {
      const response = await this.request<SendVerificationCodeResponse>('/smsverification/send', {
        method: 'POST',
        body: JSON.stringify({ telefono }),
      });
      return response;
    } catch (error) {
      console.error('Error sending verification code:', error);
      throw error;
    }
  }

  async verifyCode(telefono: string, code: string): Promise<VerifyCodeResponse> {
    try {
      const response = await this.request<VerifyCodeResponse>('/smsverification/verify', {
        method: 'POST',
        body: JSON.stringify({ telefono, code }),
      });
      return response;
    } catch (error) {
      console.error('Error verifying code:', error);
      throw error;
    }
  }
}

export const smsVerificationService = new SmsVerificationService();
